<template>
  <div class="expense">
    <a-table
      class="expenseTable table"
      id="expenseTable"
      bordered
      :pagination="pagination"
      :columns="table.columns"
      :rowKey="record => record.id"
      :dataSource="table.data"
      :loading="table.loading"
      @change="handleTableChange">
    </a-table>
  </div>
</template>

<script>
import { getEquipmentExpense } from '@/api/equipmentLedger'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) this.initTableData()
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      table: {
        data: [],
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => {
              return index + 1
            },
            align: 'center',
            width: 40
          },
          {
            title: '费用',
            dataIndex: 'expense'
          },
          {
            title: '费用原因',
            dataIndex: 'reason'
          },
          {
            title: '关联流程信息',
            dataIndex: 'info',
            width: '30%'
          },
          {
            title: '流程时间',
            dataIndex: 'time',
            width: '30%'
          }
        ],
        loading: false
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 23,
        showSizeChanger: true,
        showQuickJumper: true
      }
    }
  },
  methods: {
    initTableData () {
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      console.log('params expense_' + this.model.id, params)
      getEquipmentExpense(params).then(res => {
        if (res.status === 0) {
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        }
      })
    },
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.initTableData()
    }
  }
}
</script>
<style lang="less" scoped >
.table /deep/ .ant-table-thead > tr > th {
  background: rgba(8, 64, 159, 0.1);
}
</style>
